import React from 'react';

import styles from './Speedometer.module.scss';
import {
  getFinalRMDDate,
  getFinalRMDMonth,
  getIsRMDBalanceAndAmountIsZero,
  getIsRMDPending,
  getRMDSummary,
} from '../../../../redux/modules/RMD/RMDSetting.selectors';
import { useDispatch, useSelector } from 'react-redux';
import {
  doesEverySystematicHaveAnAgreement,
  doesUserLEGoToTrust,
  getIsRMDFundNonIRA,
  getIsRMDSpecialPayee,
  getOnlyOWNRRMDs,
} from '../../../../redux/modules/UserFunds/userFunds.selectors';
import { appendBasePath } from '../../../../utils/nav.utils';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import successNotification from '../../../../assets/images/notification-success-icon.svg';
import {
  DELETE_MODAL,
  openModal as openModalAction,
} from '../../../../redux/modules/modals/modals.module';
import MyToolTip from '../../../Shared/MyToolTip/MyToolTip';
import config from '../../../../config/config';

const Speedometer = ({ history }) => {
  const rmdSummary = useSelector(getRMDSummary);
  const r = 160;
  const dispatch = useDispatch();
  const year = rmdSummary.rmdYear;
  const hasRMD = useSelector(getOnlyOWNRRMDs);
  const isPending = useSelector(getIsRMDPending);
  const finalDate = useSelector(getFinalRMDDate);
  const finalMonth = useSelector(getFinalRMDMonth);
  const isAutoRMDPending = isPending.pending;
  const sytematicsMatch = useSelector(doesEverySystematicHaveAnAgreement);
  const RMDBalanceAndAmountIsZero = useSelector(getIsRMDBalanceAndAmountIsZero);
  const isRMDSpecialPayee = useSelector(getIsRMDSpecialPayee);
  const isRMDFundNonIRA = useSelector(getIsRMDFundNonIRA);
  const userLETrust = useSelector(doesUserLEGoToTrust);
  const rmdIsHidden = hasRMD?.some((fund) => fund.hidden);
  const showCallToEdit =
    userLETrust ||
    // RMDBalanceAndAmountIsZero ||
    isRMDSpecialPayee ||
    isRMDFundNonIRA ||
    !sytematicsMatch ||
    rmdIsHidden;
  const percentTaken =
    rmdSummary.actualDistributionTotal / rmdSummary.totalRMD || 0;
  let percentDistributedGauge =
    percentTaken * 100 >= 0.01 && percentTaken * 100 <= 0.99
      ? 0.75
      : percentTaken * 75;
  if (percentDistributedGauge > 75) {
    percentDistributedGauge = 75;
  }
  let percentDistributed =
    percentTaken * 100 >= 1
      ? Math.floor(percentTaken * 100)
      : percentTaken * 100 >= 0.01 && percentTaken * 100 <= 0.99
      ? Math.ceil(percentTaken * 100)
      : Math.floor(percentTaken * 100);
  if (percentDistributed > 100) {
    percentDistributed = 100;
  }
  const dashArr = 2 * Math.PI * r;
  const dashOffset = dashArr * ((100 - percentDistributedGauge) / 100);
  return (
    <div className={styles['speedometer']}>
      <svg className={styles['parent-circle']}>
        <circle className={styles['circle-background']} />
        {dashArr !== 0 && (
          <circle
            className={styles['circle-percent']}
            strokeDasharray={dashArr}
            strokeDashoffset={dashOffset}
          />
        )}
      </svg>
      {hasRMD.length === 0 && rmdSummary.actualDistributionTotal === 0 && (
        <div className={styles['text']}>
          <div className={styles['speedometer-header']}>Set up an Auto-RMD</div>
          <div className={styles['speedometer-subheader']}>
            It's quick, easy & recalculates each year
          </div>
        </div>
      )}
      {hasRMD.length === 0 &&
        rmdSummary.actualDistributionTotal !== 0 &&
        rmdSummary.actualDistributionTotal < rmdSummary.totalRMD && (
          <div className={styles['text']}>
            <div className={styles['speedometer-percent-header']}>
              {percentDistributed}%
            </div>
            <div className={styles['speedometer-subheader-fulfilled']}>
              Fulfilled
            </div>
          </div>
        )}
      {hasRMD.length === 0 &&
        rmdSummary.actualDistributionTotal !== 0 &&
        rmdSummary.actualDistributionTotal >= rmdSummary.totalRMD && (
          <div className={styles['text']}>
            <img className={styles['image']} alt="" src={successNotification} />
            <div className={styles['speedometer-subheader-image']}>
              You have fulfilled your {year} RMD
            </div>
          </div>
        )}
      {hasRMD.length > 0 && (
        <div className={styles['text']}>
          {isAutoRMDPending && (
            <span>
              <div className={styles['has-rmd-header']}>
                Auto-RMD:
                <div className={styles['has-rmd-header-status']}>
                  Status Pending
                </div>
                <div className={styles['has-rmd-pending']}>
                  Your Auto-RMD is being processed, please allow up to 5
                  business days
                </div>
              </div>
            </span>
          )}
          {!isAutoRMDPending &&
            rmdSummary.actualDistributionTotal < rmdSummary.totalRMD && (
              <span>
                <div className={styles['has-rmd-header']}>
                  Auto-RMD:
                  <div className={styles['has-rmd-header-status']}>On</div>
                </div>
              </span>
            )}
          {hasRMD.length !== 0 && !isAutoRMDPending && !showCallToEdit && (
            <span className={styles['edit-delete']}>
              <button
                href="https://www.troweprice.com/usis/rmd-tool/edit/destination"
                className={styles['delete']}
                onClick={(e) =>
                  history.push(appendBasePath('/edit/destination'))
                }
              >
                Edit
              </button>
              <span className={styles['vertical-line']} />
              <button
                id="delete-auto-rmd"
                onClick={(e) =>
                  dispatch(openModalAction(DELETE_MODAL, { isEdit: true }))
                }
                className={styles['delete']}
              >
                Delete
              </button>
            </span>
          )}
          {showCallToEdit && (
            <span className={styles['tool-tip']}>
              <MyToolTip
                id={'Call-to-edit-in-speedometer'}
                descriptionBody={
                  <p className={styles['desc-text']}>
                    Please{' '}
                    <a
                      href={`${config.url}/personal-investing/help/contact/index.html`}
                      rel="noopener noreferrer"
                      target="_blank"
                      className={styles['contact-us-link']}
                    >
                      contact us
                    </a>{' '}
                    to make changes to your Required Minimum Distribution.
                  </p>
                }
                callerNode={
                  <span className={styles['pending-trade']}>Call to Edit</span>
                }
                maxNoteWidth="300px"
              />
            </span>
          )}
          {!isAutoRMDPending &&
            rmdSummary.actualDistributionTotal >= rmdSummary.totalRMD && (
              <span>
                <div className={styles['has-rmd-header']}>
                  Auto-RMD:
                  <div className={styles['has-rmd-header-status']}>On</div>
                  <div className={styles['has-rmd-pending-fulfilled']}>
                    You have fulfilled your {year} RMD
                  </div>
                </div>
              </span>
            )}
        </div>
      )}
      {hasRMD.length === 0 &&
        rmdSummary.actualDistributionTotal < rmdSummary.totalRMD && (
          <span>
            <button
              id={'speedometer-enable-auto-RMD'}
              className={styles['enable-button']}
              onClick={(e) => history.push(appendBasePath('/start'))}
            >
              Enable Auto-RMD
            </button>
            <a href="#other-options" className={styles['other-ways']}>
              Explore other ways to take my RMD
            </a>
          </span>
        )}
    </div>
  );
};

export default compose(withRouter)(Speedometer);
